import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ExternalProjectContactsTable from './ExternalProjectContactsTable';
import { ExternalProjectContactItem } from '../../../models/ProjectContacts';

import { ProjectId } from '../../../models/Types';
import { fetchExternalProjectContacts, fetchHourlyRates } from '../actions';
import { getExternalProjectContactsIsFetching } from '../../../apps/main/rootReducer';
import { makePrioStyles } from '../../../theme/utils';
import { useProjectContacts } from '../hooks/useProjectContacts';
import useContactsContext from '../../contacts/hooks/useContactsProvider';

const useStyles = makePrioStyles((theme) => ({
  root: {},
  table: {},
}));

interface ExternalProjectContactsTablePageProps {
  projectId: ProjectId;
}

export const ExternalProjectContactsTablePage: React.FC<
  ExternalProjectContactsTablePageProps
> = (props) => {
  //#region ------------------------------ Defaults
  const classes = useStyles();
  const { projectId } = props;

  const dispatch = useDispatch();
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  const { getContactById } = useContactsContext();

  const { externalProjectContacts } = useProjectContacts(projectId);

  const contactItems: ExternalProjectContactItem[] = externalProjectContacts
    .map((item) => ({
      externalProjectContact: item,
      contact: getContactById(item.contactId),
    }))
    .filter((item) => item.contact !== undefined);

  const isFetching = useSelector(getExternalProjectContactsIsFetching);
  //#endregion

  //#region ------------------------------ Methods / Handlers
  //#endregion

  //#region ------------------------------ Effects
  useEffect(() => {
    dispatch(fetchHourlyRates(projectId));
  }, [dispatch, projectId]);

  useEffect(() => {
    dispatch(fetchExternalProjectContacts(projectId));
  }, [dispatch, projectId]);
  //#endregion

  return (
    <ExternalProjectContactsTable
      className={classes.table}
      contactItems={contactItems}
      projectId={projectId}
      loading={isFetching && contactItems.length === 0}
    />
  );
};

export default ExternalProjectContactsTablePage;
